<template>
  <!-- RATE DATE TO COMPARE -->
  <div :id="$options.name">
    <v-row>
      <v-col cols="12" class="pt-0 pb-2">
        <a-rms-strategy-weeks
          ref="a-rms-strategy-weeks"
          :event_period="event_period"
        ></a-rms-strategy-weeks>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import aRmsStrategyWeeks from "@/components/rms/axel/aRmsStrategyWeeks";

export default {
  name: "rms-strategy-app",
  components: {
    aRmsStrategyWeeks
  },
  props: {
    event_period: {
      type: Array,
      default: () => []
    }
  }
};
</script>
